const TrophySmallIcon = ({ color = '#475569' }) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5 2.5h6v2.7a3 3 0 0 1-6 0V2.5Z" stroke={color} strokeWidth="1.2" strokeLinejoin="round" />
    <path d="M5 3.3H3v1.5A2 2 0 0 0 5 6.8M11 3.3h2v1.5a2 2 0 0 1-2 2" stroke={color} strokeWidth="1.2" strokeLinecap="round" />
    <path d="M8 8.3v2.4M6 13.5h4M7 13.5l.4-2.8h1.2l.4 2.8" stroke={color} strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)

export default TrophySmallIcon
